<template>
  <div></div>
</template>

<script>
import AuthService from "@/services/AuthService.js";

export default {
  created() {
    AuthService.logout().then(response => {
      if (response.status == 200) {
        this.$store.dispatch("setUser", null);
        localStorage.setItem("isUserLogged", false);
        this.$router.push("/");
      }
    });
  }
};
</script>
